// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase, TelemetryType } from "@msnews/telemetry-contracts";
import { genericTelemetryClickDispatcher, getPageContentType } from "../../Social.telemetry";

export interface CommentBoxTelemetryObjects {
    postViolationAI: TelemetryObjectBase;
    postHumanReview: TelemetryObjectBase;
    sendComment: TelemetryObjectBase;
    signIn?: TelemetryObjectBase;
}

export const commentBoxTelemetryContracts = {
    postViolationAI: {
        name: "PostViolationAI",
        content: {type: TelemetryContentType.Comment}
    },
    postHumanReview: {
        name: "PostHumanReview",
        content: {type: TelemetryContentType.Comment}
    },

    /** Comments-Scenario 5a */
    sendReply: {
        name: "Reply",
        behavior: TelemetryBehaviorType.Comment,
        content: {
            type: TelemetryContentType.Comment,
            headline: "Post"
        }
    },
    /** Comments-Scenario 5 */
    sendComment: {
        name: "Post",
        behavior: TelemetryBehaviorType.Comment,
        content: {
            type: getPageContentType(),
            headline: "Post"
        }
    },
    /** Comments-Scenario 4a */
    signIn: {
        name: "SignIn",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: getPageContentType(),
            headline: "SignIn"
        }
    }
};

export const commentBoxTelemetryActionDispatchers = {
    genericClick: genericTelemetryClickDispatcher
};